import { render, staticRenderFns } from "./ListarBoletosNaoEncontrados.vue?vue&type=template&id=628a36b8&"
import script from "./ListarBoletosNaoEncontrados.vue?vue&type=script&lang=js&"
export * from "./ListarBoletosNaoEncontrados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports